import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from ".";

export interface UserData {
  isLoggedIn: boolean;
  _id?: string;
  sessionToken: string;
  tokens?: string[];
  inviteCode?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  hash?: string;
  telegramID?: number;
  registeredDate?: Date;
  totalProfitARTC?: number;
  totalARTC?: number;
  freeARTCtakenDate?: string;
  freeARTCtakenLeft?: number;
  isDeleted?: boolean;
  totalCorrectVotesCount?: number;
  totalVotesCount?: number;
  totalFinishedBattlesVotesCount?: number;
  captchaErrors?: number;
  isBlockedDate?: Date;
  slotsBought?: number;
  votesSlotUnlocked?: boolean;
  totalFinishedBattlesCount?: number;
  battlesSlotUnlocked?: boolean;
  totalNFTsCount?: number;
  nftsSlotUnlocked?: boolean;
  totalInvitedFriendsCount?: number;
  totalInvitedActiveUsersCount?: number;
  invitesSlotUnlocked?: boolean;
  paidSlotUnlocked?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  id?: string;
  notificationsCount: number;
}

const initialState: UserData = {
  isLoggedIn: false,
  notificationsCount: 0,
  sessionToken: "",
  // sessionToken:
  //   process.env.REACT_APP_ENV_MODE === "development"
  //     ? process.env.REACT_APP_JWT_COOKIE || ""
  //     : "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSessionToken(userState, { payload }: PayloadAction<string>) {
      userState.sessionToken = payload;
    },
    setIsLoggedIn(userState, { payload }: PayloadAction<boolean>) {
      userState.isLoggedIn = payload;
    },
    setNotificationsCount(userState, { payload }: PayloadAction<number>) {
      userState.notificationsCount = payload;
    },
    setUserData(userState, { payload }: PayloadAction<UserData>) {
      if (payload.id !== null) userState._id = payload.id;
      if (payload.inviteCode !== null)
        userState.inviteCode = payload.inviteCode;
      if (payload.firstName !== null) userState.firstName = payload.firstName;
      if (payload.lastName !== null) userState.lastName = payload.lastName;
      if (payload.userName !== null) userState.userName = payload.userName;
      if (payload.telegramID !== null)
        userState.telegramID = payload.telegramID;
      if (payload.registeredDate !== null)
        userState.registeredDate = payload.registeredDate;
      if (payload.totalProfitARTC !== null)
        userState.totalProfitARTC = payload.totalProfitARTC;
      if (payload.totalARTC !== null) userState.totalARTC = payload.totalARTC;
      if (payload.freeARTCtakenDate !== null)
        userState.freeARTCtakenDate = payload.freeARTCtakenDate;
      if (payload.freeARTCtakenLeft !== null)
        userState.freeARTCtakenLeft = payload.freeARTCtakenLeft;
      if (payload.isDeleted !== null) userState.isDeleted = payload.isDeleted;
      if (payload.totalCorrectVotesCount !== null)
        userState.totalCorrectVotesCount = payload.totalCorrectVotesCount;
      if (payload.totalFinishedBattlesVotesCount !== null)
        userState.totalFinishedBattlesVotesCount =
          payload.totalFinishedBattlesVotesCount;
      if (payload.totalVotesCount !== null)
        userState.totalVotesCount = payload.totalVotesCount;
      if (payload.captchaErrors !== null)
        userState.captchaErrors = payload.captchaErrors;
      if (payload.isBlockedDate !== null)
        userState.isBlockedDate = payload.isBlockedDate;
      if (payload.slotsBought !== null)
        userState.slotsBought = payload.slotsBought;
      if (payload.votesSlotUnlocked !== null)
        userState.votesSlotUnlocked = payload.votesSlotUnlocked;
      if (payload.totalFinishedBattlesCount !== null)
        userState.totalFinishedBattlesCount = payload.totalFinishedBattlesCount;
      if (payload.battlesSlotUnlocked !== null)
        userState.battlesSlotUnlocked = payload.battlesSlotUnlocked;
      if (payload.totalNFTsCount !== null)
        userState.totalNFTsCount = payload.totalNFTsCount;
      if (payload.nftsSlotUnlocked !== null)
        userState.nftsSlotUnlocked = payload.nftsSlotUnlocked;
      if (payload.totalInvitedFriendsCount !== null)
        userState.totalInvitedFriendsCount = payload.totalInvitedFriendsCount;
      if (payload.totalInvitedActiveUsersCount !== null)
        userState.totalInvitedActiveUsersCount =
          payload.totalInvitedActiveUsersCount;
      if (payload.invitesSlotUnlocked !== null)
        userState.invitesSlotUnlocked = payload.invitesSlotUnlocked;
      if (payload.paidSlotUnlocked !== null)
        userState.paidSlotUnlocked = payload.paidSlotUnlocked;
      if (payload.createdAt !== null) userState.createdAt = payload.createdAt;
      if (payload.updatedAt !== null) userState.updatedAt = payload.updatedAt;
      if (payload.id !== null) userState.id = payload.id;
    },
  },
});

export const {
  setSessionToken,
  setIsLoggedIn,
  setUserData,
  setNotificationsCount,
} = userSlice.actions;

export const userState = createSelector(
  (state: RootState) => state.user,
  (userState): UserData => {
    return userState;
  }
);

export default userSlice.reducer;
